import { Form, Row, Col } from 'react-bootstrap';
import {
  CARES_TYPES,
  CARES_TYPE_VALUES,
  CARES_GRANT_OPTIONS,
  MAX_CARES_GRANTS,
  MAX_CARES_AMOUNT
} from '../../../../constants/constants';
import CaresAlert from './CaresAlert';
import Required from '../../../../utils/Required';

const CaresTypeSelector = ({
  caresType,
  onChange,
  isSubmitting,

  // CARES context
  numGrantsApplied,
  appliedGrantsTotal,
  hasExistingCaresIncomeData,
  
  // side effects (delegated upward)
  onShowExceptionModal,
}) => {

  const caresMaxMet = numGrantsApplied >= MAX_CARES_GRANTS || appliedGrantsTotal >= MAX_CARES_AMOUNT;

  const handleChange = (value) => {    
    // CARES max met + grant option => exception modal
    if (CARES_GRANT_OPTIONS.includes(value) && caresMaxMet) {
      onShowExceptionModal();
      return;
    }

    onChange(value);
  };

  const allowedTypes = CARES_TYPES.filter(ct => {
    // NEWGRANT: only allowed if existing income data OR max met (exception path)
    if (ct.value === CARES_TYPE_VALUES.NEWGRANT) {
      return hasExistingCaresIncomeData && !caresMaxMet;
    }

    // NEWGRANT: only allowed if existing income data OR max met (exception path)
    if (ct.value === CARES_TYPE_VALUES.EXCEPTIONREQUEST) {
      return caresMaxMet;
    }

    // CHANGE options require active discount
    if (CARES_TYPE_VALUES.CHANGEDISCOUNT === ct.value) {
      return hasExistingCaresIncomeData;
    }

    if (CARES_TYPE_VALUES.CHANGEDISCOUNTANDNEWGRANT === ct.value) {
      return hasExistingCaresIncomeData && !caresMaxMet;
    }

    if (
      [CARES_TYPE_VALUES.NEWDISCOUNT,
       CARES_TYPE_VALUES.NEWDISCOUNTANDGRANT].includes(ct.value)
    ) {
      return !hasExistingCaresIncomeData;
    }

    // default exclude
    return false;
  });

  return (
    <>
      <Row>
        <Col md={6}>
          {/* <h4>What would you like to do?</h4> */}
          <Form.Group className="mb-3">
            <Form.FloatingLabel label={<Required>Select CARES Form Type</Required>} controlId="cares-type-selector">
              
            <Form.Select
              value={caresType}
              onChange={e => handleChange(e.target.value)}
              disabled={isSubmitting}
              required
            >
              <option value="">-</option>
              {allowedTypes.map(ct => (
                <option key={ct.value} value={ct.value}>
                  {ct.label}
                </option>
              ))}
            </Form.Select>
            <Form.Control.Feedback type="invalid">
              Please select a CARES Form Type.
            </Form.Control.Feedback>
          </Form.FloatingLabel>

          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col>
          <CaresAlert
            numGrantsApplied={numGrantsApplied}
            appliedGrantsTotal={appliedGrantsTotal}
            hasActiveDiscount={hasExistingCaresIncomeData}
          />
        </Col>
      </Row>
    </>
  );
};

export default CaresTypeSelector;